import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import moment from 'moment';


const downloadpdf = (pdfType, urldata, filename) => {
    // console.log("urldata", urldata);
    return new Promise((resolve, reject) => {


        axios.post(config.basePath + 'pdf/downloadpdf',
            { pdfType: pdfType, urldata: urldata, filename: filename },
            { responseType: 'blob' }).then(response => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                // Create a temporary link element to initiate the file download
                const link = document.createElement('a');
                link.href = url;
                let filenameCapitalized = filename.charAt(0).toUpperCase() + filename.slice(1);

                link.setAttribute('download', filenameCapitalized + "_" + moment().format('YYYYMMDDHHmm') + ".pdf"); // Set the desired file name
                document.body.appendChild(link);
                link.click();

                // Clean up the temporary URL and link element
                URL.revokeObjectURL(url);
                document.body.removeChild(link);
                resolve({
                    success: true,
                    message: "File downloaded successfully"
                })
            }).catch((err) => {
                if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                    reject({
                        message: err.response.data.message
                    })
                } else {
                    reject({
                        message: "Unable to download pdf"
                    })
                }
            })

    })

}
const pdfService = {
    downloadpdf
}

export default pdfService 
